import { render, staticRenderFns } from "./Settings.container.vue?vue&type=template&id=36c015b9&scoped=true&"
import script from "./Settings.container.vue?vue&type=script&lang=js&"
export * from "./Settings.container.vue?vue&type=script&lang=js&"
import style0 from "./Settings.container.vue?vue&type=style&index=0&id=36c015b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c015b9",
  null
  
)

export default component.exports